export default from './comment-edit-page-header';



// WEBPACK FOOTER //
// ./app/containers/comment-edit-page-header/index.js